export const CHART_MIN_WIDTH = 400;
export const CHART_MAX_STRING_LENGTH = 10;
export const CHART_DATA_EMPTY_KEY_PREFIX = 'empty_key_';
